import React, { useMemo, useState } from 'react';
import Link from 'react-router/es/Link';
import { useSelector, useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';

import InlineInput from '../../InlineInput';
import ShareModal from '../../ShareModal';
import SlideOutMenu from '../../SlideOutMenu';
import AdSection from '../../AdSection';
import SiteNav from '../../SiteNav';
import Message from '../Message';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';

import { getBaseRoute } from '../../WebCommunity';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './MessageDetails.module.scss';

const { leaveComment, trackAds } = webCommunityOperations;

const {
  'message-details': messageDetailsClass,
  'page-content': pageContentClass,
  'message-ad-container': messageAndAdContainer,
  'decedent-bar-btn': decedentBarClass
} = styles;

const MessageDetails = ({ location, routeParams }) => {
  const { inviteId, messages, userName, inviteMeta, eventsArray = [] } = useSelector(
    ({ webCommunity, authUser }) => ({
      inviteId: webCommunity.inviteMeta?.data?._id,
      messages: webCommunity.messages?.array,
      userName: authUser?.data?.name,
      inviteMeta: webCommunity?.inviteMeta?.data,
      eventsArray: webCommunity.events.array
    })
  );
  const dispatch = useDispatch();
  const { messageId } = routeParams;
  const baseRoute = getBaseRoute(location?.pathname);
  const { shareUrl, ads = [] } = inviteMeta ?? {};

  const postEvents = !eventsArray.length;
  const placementType = postEvents
    ? 'communityMessageDetailsPostServices'
    : 'communityMessageDetails';
  const findAdsCb = ({ placementType: adDataPlacementType }) =>
    placementType === adDataPlacementType;
  const messageDetailsAdData = !!ads.length && ads.find(findAdsCb);

  const [isShareModalOpen, setShareModalOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const inputPlaceholder = 'Write your message here...';

  // scroll to top on mount
  useScrollToTop();

  // select message from message list
  const message = useMemo(() => {
    return messages.find(({ _id }) => _id.toString() === messageId);
  }, [messageId, messages]);

  const handleComment = ({ message }) => {
    if (!!userName) {
      dispatch(
        leaveComment({
          memorialId: inviteId,
          mediaId: messageId,
          message
        })
      );
    } else {
      // open anonymous flow to confirm name, phone, email before sending
      const pathname = `${baseRoute}/condolence/create-user`;
      browserHistory.push({
        pathname,
        state: { pendingComment: { message, mediaId: messageId } }
      });
    }
  };

  const handleToggleShareMenu = () => setShareModalOpen(prev => !prev);

  const DecedentBarBtn = () => (
    <button className={decedentBarClass} onClick={handleToggleShareMenu}>
      Share
    </button>
  );

  return (
    <div className={messageAndAdContainer}>
      <SiteNav showDecedentBar decedentBarContent={DecedentBarBtn} />
      <div className={messageDetailsClass}>
        <div className={pageContentClass}>
          <Link to={location.pathname.replace(/\/messages\/.*/, '')}>&#60; Back</Link>
          <Message {...{ ...message, userName }} />
          <InlineInput
            name="message"
            placeholder={inputPlaceholder}
            onSubmit={handleComment}
            initialValue={location?.state?.message}
          />
        </div>
        <ShareModal
          closeModal={() => setShareModalOpen(false)}
          modalVisible={isShareModalOpen}
          shareUrl={shareUrl}
        />
        <SlideOutMenu {...{ isMenuOpen }} closeMenu={() => setMenuOpen(false)} />
      </div>
      <AdSection {...{ trackAds }} memorialId={inviteId} adData={messageDetailsAdData} />
    </div>
  );
};

export default MessageDetails;
